import { tickerItems } from "@/mocks/home";

function TickerCard({ text, time }: { text: string; time: string }) {
  return (
    <div className="flex shrink-0 items-center gap-2 border-r border-background-300/50 px-5">
      <span className="flex h-1.5 w-1.5 shrink-0 rounded-full bg-primary-500" />
      <span className="max-w-[360px] truncate text-xs text-foreground-800">{text}</span>
      <span className="shrink-0 text-[11px] text-foreground-500">{time}</span>
    </div>
  );
}

export default function TickerStrip() {
  const doubled = [...tickerItems, ...tickerItems];
  return (
    <section className="border-y border-background-200/70 bg-background-100/50">
      <div className="mx-auto flex w-full max-w-[1400px] items-center gap-2 px-4 py-2.5 md:px-6">
        <span className="flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full bg-primary-500/15 px-2.5 py-1 text-xs font-semibold text-primary-300">
          <i className="ri-radio-line text-sm" />
          实时速览
        </span>
        <div className="no-scrollbar relative flex-1 overflow-hidden">
          <div className="marquee-track items-center py-1">
            {doubled.map((it, i) => (
              <TickerCard key={i} text={it.text} time={it.time} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}